import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { CommunityDetailDataObject } from 'models/service';

type UpdateCommunityRequest = {
  cover_photo?: EntityReferenceRailsRequestData;
  description?: string;
  html_description?: string;
};

export const updateCommunity = async (communityId: string, data: UpdateCommunityRequest) =>
  apiClient.patch<CommunityDetailDataObject, ApiClientResponse<CommunityDetailDataObject>>(
    routes.community.update(communityId),
    {
      community: data,
    },
  );
